const B64_PATTERN = /^([a-zA-Z0-9+/\-_.])+$/;

export function isValidBase64(text = '') {
  return !!text && B64_PATTERN.test(text);
}
